import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'transform' })
export class TransformPipe implements PipeTransform {
    transform<TValue, TReturn>(value: TValue, fn: (arg: TValue) => TReturn): TReturn {
        return fn(value);
    }
}
